import * as actionTypes from './actionTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reducer(state:{}, action:{ payload: any, type: string }) {
  switch (action.type) {    
    case actionTypes.SET_AUTH_STATE:
      return {
        ...state,
        authState: action.payload,
      };
    
    case actionTypes.SET_DEFAULT_SITE:
      return {
        ...state,
        defaultOrganisation: action.payload,
      };

    case actionTypes.AUTHORISE_EMPLOYEE:
      return {
        ...state,
        auth: true,
        employee: action.payload,
      };

    case actionTypes.SET_USER:
      return {
        ...state,
        user: action.payload,
      };
  
    case actionTypes.SET_TOKEN:
      return {
        ...state,
        V2Token: action.payload,
      };

    case actionTypes.SET_DISPATCHER_TOKEN:
      return {
        ...state,
        V2DispatcherToken: action.payload,
      };

    case actionTypes.UNAUTHORISE_EMPLOYEE:
      return {
        ...state,
        auth: false,
        employee: {},
        V2Token: '',
        V2DispatcherToken: '',
      };

    default:
      return state;
  }
}

export default reducer;
